import { Locale, type LocalizedString } from "../Locale.js";
import type { Tenant } from "../Tenant.js";
import { getPathInLocale } from "./getPathInLocale.js";

export function getAccountingPath(tenant: Tenant): string {
	const pathMap: LocalizedString = {
		[Locale.cs]: "/odvetvi/ucetnictvi",
		[Locale.en]: "/industries/accounting",
	};

	return getPathInLocale(tenant.locale, pathMap);
}
